module.exports = __webpack_public_path__ + "static/media/Pin_Job_Motorcycle.2f5830f3.svg";